import { jsxs as r, Fragment as l, jsx as C } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ r(l, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M4 7.72042L8.5 4.13751L10.8392 6H10.8357L13.2133 7.8913C13.3018 7.96168 13.4116 8 13.5246 8H14.4736C14.7643 8 15 7.76433 15 7.47361C15 7.03595 14.807 6.62119 14.4736 6.33815C14.4616 6.32799 14.4495 6.318 14.4372 6.30818L9.43715 2.32716C8.88928 1.89095 8.11071 1.89095 7.56284 2.32716L2.18762 6.60692C2.06915 6.70125 2 6.84414 2 6.99542V13.5074C2 14.3317 2.67157 15 3.5 15H7C7.55228 15 8 14.5523 8 14C8 13.4477 7.55228 13 7 13H4V7.72042Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M11 10C10.4477 10 10 10.4477 10 11C10 11.5523 10.4477 12 11 12H12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10H11Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M15 11C15 10.4477 15.4477 10 16 10H21C21.5523 10 22 10.4477 22 11C22 11.5523 21.5523 12 21 12H16C15.4477 12 15 11.5523 15 11Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M15 15C15 14.4477 15.4477 14 16 14H21C21.5523 14 22 14.4477 22 15C22 15.5523 21.5523 16 21 16H16C15.4477 16 15 15.5523 15 15Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M15 19C15 18.4477 15.4477 18 16 18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H16C15.4477 20 15 19.5523 15 19Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M11 14C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H12C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14H11Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M11 18C10.4477 18 10 18.4477 10 19C10 19.5523 10.4477 20 11 20H12C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18H11Z",
      fill: "currentColor"
    }
  )
] });
export {
  o as default
};
